module.exports = __webpack_public_path__ + "img/gift.1d0fcc24.gif";